<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          NO: {{ formData.materialAbnormalNo || 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.materialAbnormalStatus === 'Y'
              ? 'success'
              : formData.materialAbnormalStatus === 'S'
              ? 'warning'
              : formData.materialAbnormalStatus === 'D' ||
                formData.materialAbnormalStatus === 'R'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_materialAbnormalStatus || 'New' }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify: {{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_salesPersonCode') || '业务人员'"
            prop="salesPersonCode"
          >
            <dict-select
              v-model="formData.salesPersonCode"
              url="/master/common/dict/baseUserSelect"
              :selectedLabel.sync="formData.salesPersonName"
              :placeholder="
                $l('INDEX.form_label_please_select_a_business_person') ||
                  '请选择业务人员'
              "
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.table_label_requestDate') || '申请日期'"
            prop="requestDate"
          >
            <el-date-picker
              v-model="formData.requestDate"
              :picker-options="requestDatePicker"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('table_label_abnormal_procurement') || '超采原因'"
            prop="abnormalProcurement"
          >
            <dict-select
              v-model="formData.abnormalProcurement"
              url="/master/common/dict/biz"
              :body="abnormalProcurementParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              size="mini"
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('table_label_expected_date') || '预计处理日期'"
            prop="expectedDate"
          >
            <el-date-picker
              v-model="formData.expectedDate"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('table_label_actual_date') || '实际处理日期'"
          >
            <el-date-picker
              v-model="formData.actualDate"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              disabled
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('table_label_fin_confirm_date') || '财务确认日期'"
          >
            <el-date-picker
              v-model="formData.finConfirmDate"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              disabled
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('table_label_currencyAmount') || '费用合计'">
            <el-input v-model="v_currencyAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.table_label_currencyUnit') || '货币单位'"
            prop="currencyUnit"
          >
            <dict-select
              v-model="formData.currencyUnit"
              url="/master/common/dict/biz"
              :body="currencyUnitParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('table_label_costParty') || '费用承担方'"
            prop="costParty"
          >
            <dict-select
              v-model="formData.costParty"
              url="/master/common/dict/biz"
              :body="costPartyParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('table_label_costPartyAmount') || '承担金额'"
            prop="costPartyAmount"
          >
            <el-input-number
              :controls="false"
              style="width: 100%"
              size="mini"
              :min="0"
              :step="0.01"
              :precision="3"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.costPartyAmount"
            ></el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('table_label_deductionMethod') || '费用处理方式'"
            prop="deductionMethod"
          >
            <dict-select
              v-model="formData.deductionMethod"
              url="/master/common/dict/biz"
              :body="deductionMethodParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="8">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('INDEX.purchase_form_label_scmName') || '供应商'"
                prop="scmCode"
              >
                <dict-select
                  v-model="formData.scmCode"
                  url="/master/common/dict/allScmCooperated"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                  size="mini"
                  clearable
                  filterable
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt-2">
            <el-col :span="24">
              <el-form-item
                :label="$l('table_label_cust') || '订单客户'"
                prop="custCode"
              >
                <dict-select
                  v-model="formData.custCode"
                  :selectedLabel.sync="formData.custName"
                  url="/digitalCenter/common/dict/customer"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                  size="mini"
                  clearable
                  filterable
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="16">
          <el-form-item :label="$l('table_label_description') || '情况说明'">
            <el-input
              v-model="formData.description"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              :rows="5"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <ItemTable
          ref="itemTable"
          :disabled="disabled"
          :materialAbnormalCode="materialAbnormalCode"
          @updateTotAmount="(e) => (formData.currencyAmount = e)"
          :custCode="formData.custCode"
          :custName="formData.custName"
        />
      </el-row>
      <el-row>
        <DocTable
          ref="docTable"
          :disabled="disabled"
          :materialAbnormalCode="materialAbnormalCode"
        />
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ItemTable from '../item-table'
import DocTable from '../doc-table'
import dayjs from 'dayjs'
export default {
  components: { ItemTable, DocTable },
  mixins: [EditLoading],
  props: {
    materialAbnormalCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      requestDatePicker: this.requestDateEnd(),
      abnormalProcurementParams: { dictType: 'abnormalProcurement' },
      expensePayerParams: { dictType: 'expensePayer' },
      costPartyParams: { dictType: 'costParty' },
      deductionMethodParams: { dictType: 'deductionMethod' },
      currencyUnitParams: { dictType: 'bankAccountKind' },
      paymentMethodParams: { dictType: 'paymentMethod' },
      formData: {
        abnormalProcurement: '',
        salesPersonCode: '',
        salesPersonName: '',
        costParty: '',
        deductionMethod: '',
        scmCode: '',
        custCode: '',
        currencyAmount: 0,
        description: '',
        requestDate: dayjs(new Date()).format('YYYY-MM-DD'),
      },
    }
  },
  computed: {
    v_currencyAmount() {
      const { currencyAmount } = this.formData
      return !currencyAmount ? '0' : currencyAmount.toLocaleString()
    },
    rules() {
      return {
        salesPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        requestDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        expectedDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        costParty: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        deductionMethod: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        abnormalProcurement: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        scmCode: [
          {
            required: this.formData.costParty == 'B',
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        custCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        costPartyAmount: [
          {
            validator: (rule, value, callback) => {
              if (!value && value != 0) {
                return callback(
                  new Error(this.$l('INDEX.tips_input_placeholder') || '请输入')
                )
              }
              setTimeout(() => {
                if ((value || 0) > this.formData.currencyAmount) {
                  callback(
                    new Error(
                      this.$l('tip_label_abnormal_procurement') ||
                        '承担金额不能大于费用合计'
                    )
                  )
                } else {
                  callback()
                }
              }, 500)
            },
            // message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            required: true,
            trigger: 'change',
          },
        ],
      }
    },
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        if (this.materialAbnormalCode) return
        if (!userInfo || userInfo == {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.salesPersonCode = userCode || ''
        this.formData.salesPersonName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    requestDateEnd() {
      return {
        disabledDate(time) {
          //如果结束时间不为空，则小于结束时间
          return new Date().getTime() < time.getTime()
        },
      }
    },
    reload() {
      this.getData()
      this.$refs.itemTable.loadData()
      this.$refs.docTable.loadData()
    },
    getData() {
      if (!this.materialAbnormalCode) return
      this.$api
        .materialAbnormalDetailApi({
          materialAbnormalCode: this.materialAbnormalCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await this.formValidate()
      if (!result) return

      const listItem = this.$refs.itemTable.getTableData()
      if (!listItem || listItem.length < 1) {
        this.$message.warning(
          this.$l('tips_please_add_expense_item') || '请添加费用填报明细'
        )
        return
      }

      const listDoc = this.$refs.docTable.getTableData() || []

      const custCodeList = listItem.filter(
        (e) => e.custCode != this.formData.custCode
      )
      if (custCodeList && custCodeList.length) {
        this.$message.warning(
          this.$l('tip_label_please_check_and_save_again') ||
            '费用填报明细存在不是当前订单客户的数据，请检查后重新保存'
        )
        return
      }
      this.loadingOpen()
      this.$api
        .materialAbnormalSaveApi({ ...this.formData, listItem, listDoc })
        .then(async () => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          if (!this.materialAbnormalCode) {
            this.closeCurPage()
          } else {
            this.reload()
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async formValidate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const itemTableResult = await this.$refs.itemTable.validate()
      return formResult && itemTableResult
    },
    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
